import {  isEqual } from "lodash"
import { CustomSurvey } from "../../models"
import { ICustomSurveyFormData } from "../../components"
import { t } from "ttag"

interface IValidator {
  isDirty: (surveyForm: ICustomSurveyFormData, customSurvey?: CustomSurvey) => boolean,
}

interface NonRequiredValidator extends IValidator {
  isRequired: false,
}

interface RequiredValidator extends IValidator {
  isValid: (surveyForm: ICustomSurveyFormData) => boolean,
  isRequired: true,
  wording: () => string,
}

type Validator = NonRequiredValidator | RequiredValidator

export const validators: Validator[] = [
  {
    isDirty: (surveyForm, customSurvey) => {
      if (!customSurvey) {
        return !!surveyForm.surveyDetails.name
      }

      return surveyForm.surveyDetails.name !== customSurvey.name
    },
    isRequired: true,
    isValid: (surveyForm) => {
      return !!surveyForm.surveyDetails.name.trim()
    },
    wording: () => t`Having a title`,
  },
  {
    isDirty: (surveyForm, customSurvey) => {
      if (!customSurvey) {
        return !!surveyForm.surveyDetails.description
      }

      return surveyForm.surveyDetails.description !== customSurvey.description
    },
    isRequired: false,
  },
  {
    isDirty: (surveyForm, customSurvey) => {
      if (!customSurvey) {
        return surveyForm.surveyQuestions.length > 0
      }

      return !isEqual(surveyForm.surveyQuestions, customSurvey.questions)
    },
    isRequired: true,
    isValid: (surveyForm) => {
      return surveyForm.surveyQuestions.length > 0
    },
    wording: () => t`Having at least one question`,
  },
]
